import {forEach, Move} from "../../js/helpers";
import {break_sm} from "../../js/constants";
import {DistanceMap} from "./DistanceMap";

new Move(document.querySelector('[data-move="order-sum-get"]'), document.querySelector('[data-move="order-sum-set"]'), break_sm).init();

forEach(document.querySelectorAll('#cart-3-radio-content-2'), courierWrapper => {
  const buttonCourierMap = courierWrapper.querySelector('.button-courier-map');
  if (!buttonCourierMap) return;

  const distanceMapEl = courierWrapper.querySelector('.orderDistanceMap');
  if (!distanceMapEl) return;

  buttonCourierMap.addEventListener('click', () => {
    if (distanceMapEl.classList.contains('is-active')) {
      distanceMapEl.classList.remove('is-active');
    } else {
      distanceMapEl.classList.add('is-active');
      DistanceMap(distanceMapEl);
      setTimeout(() => {
        courierWrapper.style.setProperty('--max-height', courierWrapper.scrollHeight + 'px');
      }, 1000);
    }
  });
  if (courierWrapper.closest('.is-filled') && courierWrapper.getAttribute('aria-expanded') === "true") {
    setTimeout(() => {
      distanceMapEl.classList.add('is-active');
      DistanceMap(distanceMapEl);
      setTimeout(() => {
        courierWrapper.style.setProperty('--max-height', courierWrapper.scrollHeight + 'px');
      }, 1000);
    }, 2000);
  }
});

forEach(document.querySelectorAll('.time-price-list'), item => {
  forEach(item.querySelectorAll('input[type="radio"]'), checkbox => {
    checkbox.addEventListener('change', () => {
      forEach(item.parentNode.children, item => {
        item.classList.remove('is-chosen');
      });
      item.classList.add('is-chosen');
    });
  });
});
